import React, { useState } from 'react';
import {
  Box, TextField, IconButton,
} from '@mui/material';
import { EyeSlash, Eye } from '@phosphor-icons/react';

type PasswordInputProps = {
  inputRef?: () => void,
  name?: string,
  label?: string,
  value?: string,
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
  disabled?: boolean,
  required?: boolean,
};

const PasswordInput = ({
  name,
  label,
  inputRef,
  value,
  onChange,
  disabled = false,
  required = false,
}: PasswordInputProps): JSX.Element => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <Box position="relative">
      <Box position="absolute" right={8} top={label ? 24 : 8} zIndex="100">
        <IconButton
          size="small"
          onClick={() => setShowPassword((current) => !current)}
          data-testid="eye-icon-button"
        >
          {showPassword
            ? <EyeSlash size={22} data-testid="eye-slash-icon" />
            : <Eye size={22} data-testid="eye-icon" />}
        </IconButton>
      </Box>
      <TextField
          name={name}
          label={label}
          type={showPassword ? 'text' : 'password'}
          inputRef={inputRef}
          value={value}
          onChange={onChange}
          disabled={disabled}
          required={required}
          color="secondary"
          fullWidth
      />
    </Box>
  );
};

export default PasswordInput;
